export function getPlace (search) {
    return search.place || {}
}

export function getStart (search) {
    return search.start
}

export function getBounds (search) {
    if (!getPlace(search) || !getPlace(search).bounds) {
        return
    }
    return getPlace(search).bounds
}

export function getEnd (search) {
    return search.end
}

export function getLatitude (search) {
    return getPlace(search).latitude
}

export function getLongitude (search) {
    return getPlace(search).longitude
}

export function setPlace (search, place) {
    return {
        ...search,
        place,
    }
}

export function setStart (search, start) {
    return {
        ...search,
        start,
    }
}

export function setEnd (search, end) {
    return {
        ...search,
        end,
    }
}

export function setLatitude (search, latitude) {
    return {
        ...search,
        place: {
            ...search.place,
            latitude,
        },
    }
}

export function setLongitude (search, longitude) {
    return {
        ...search,
        place: {
            ...search.place,
            longitude,
        },
    }
}
